export const ADD_TO_SITE_TRANSLATION_KEY = 'tpa_add_panel_add_to_site';
